// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XCdY","icon":"styles_icon__3-42q"};